import { Component, Inject, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { AppMessageService } from 'src/app/services/app-message.service';

@Component({
  selector: 'region-lov',
  templateUrl: './region-lov.component.html',
  styleUrls: ['./region-lov.component.css']
})
export class RegionLovComponent {

  moduleId: string = 'BMM106';
  isShortDesc: boolean = false;
  private selectedData: any;
  public titleLov: string = "REGION";

  table: any = {
    cols: [
      {
        key: "regionCd",
        header: "Region Code",
        dataType: "padNumber",
        width: '30%'
      },
      {
        key: "regionDesc",
        header: "Region",
        dataType: "string",
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };

  tableShortDesc: any = {
    cols: [
      {
        key: "regionCd",
        header: "Region Code",
        dataType: "number",
        width: '30%'
      },
      {
        key: "regionDesc",
        header: "Region Short Description",
        dataType: "string",
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }
  constructor(
    private jsonDataService: JsonDataService,
    private dialogRef: MatDialogRef<RegionLovComponent>,
    private _api: APICallService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public fromMainData: any,
  ) { 
    if("desc" in this.fromMainData){
      if(this.fromMainData.desc == "SHORT"){
        this.isShortDesc= true;
        this.getShortData();
      }
      else{
        this.isShortDesc= false;
        this.getData();
      }
    }
    else{
      this.isShortDesc= false;
      this.getData();
    }
  }

  onRowClick(ev: any) {
    try {
      this.selectedData = ev;
    } catch (e) {
      console.error(e);
    }
  }

  private getData(): void {
    try {
      this.table.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getRegion({
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(data.response));
              if (content.moduleId === this.moduleId) {
                this.jsonDataService.contorlLoading(false);
                this.table.tblData = content.data.filter((d: any) =>{
                  if(d.ACTIVE_TAG === 'A'){
                    d.regionCd = d.REGION_CD;
                    d.regionDesc = d.REGION_DESC;
                    return true;
                  }else{
                    return false;
                  }
                });
                this.table.loading = false;
              } else {
                this.table.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {
            
            this.table.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
      console.error(e);
      this.table.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }

  private getShortData(): void {
    try {
      this.tableShortDesc.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getRegion({
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(data.response));
              if (content.moduleId === this.moduleId) {
                this.jsonDataService.contorlLoading(false);
                this.tableShortDesc.tblData = content.data.filter((d: any) =>{
                  if(d.ACTIVE_TAG === 'A'){
                    d.regionCd = d.REGION_CD;
                    d.regionDesc = d.REG_SHORT_DESC;
                    return true;
                  }else{
                    return false;
                  }
                });
                this.tableShortDesc.loading = false;
              } else {
                this.tableShortDesc.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {
            
            this.tableShortDesc.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
      console.error(e);
      this.tableShortDesc.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }
  onClose(str: string) {
    try {
      if (this.selectedData == '' || this.selectedData == null) {
        this.dialogRef.close({ content: '', button: str });
      }
      else {
        this.dialogRef.close({ content: this.selectedData, button: str });
      }
    } catch (e) {
      console.error(e);
    }
  }

}
